// src/BookLesson.js
import React, { useState, useEffect } from "react";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";

function BookLesson() {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [frequency, setFrequency] = useState("one-off");
  const [notes, setNotes] = useState("");
  const [message, setMessage] = useState("");

  // Fetch students from Firestore
  useEffect(() => {
    const fetchStudents = async () => {
      const querySnapshot = await getDocs(collection(db, "users"));
      const studentList = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((user) => user.role === "student");
      setStudents(studentList);
    };
    fetchStudents();
  }, []);

  const handleBooking = async (e) => {
    e.preventDefault();

    if (!selectedStudent || !date || !time || !frequency) {
      setMessage("❌ Please complete all fields.");
      return;
    }

    try {
      await addDoc(collection(db, "bookings"), {
        studentId: selectedStudent,
        date,
        time,
        frequency,
        notes,
        createdAt: new Date(),
      });

      setMessage("✅ Lesson booked successfully!");
      setSelectedStudent("");
      setDate("");
      setTime("");
      setFrequency("one-off");
      setNotes("");
    } catch (error) {
      console.error("Error booking lesson:", error);
      setMessage("❌ Failed to book lesson.");
    }
  };

  return (
    <TutorLayout>
      <div style={styles.container}>
        <h2>📚 Book a Lesson</h2>
        <form onSubmit={handleBooking} style={styles.form}>
          <select
            value={selectedStudent}
            onChange={(e) => setSelectedStudent(e.target.value)}
            required
            style={styles.input}
          >
            <option value="">Select a student</option>
            {students.map((student) => (
              <option key={student.id} value={student.id}>
                {student.displayName} {student.surname}
              </option>
            ))}
          </select>

          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
            style={styles.input}
          />

          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            required
            style={styles.input}
          />

          <select
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
            style={styles.input}
            required
          >
            <option value="one-off">📆 One-off</option>
            <option value="weekly">🔁 Weekly</option>
            <option value="fortnightly">⏱️ Fortnightly</option>
          </select>

          <textarea
            placeholder="Optional notes..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            style={{ ...styles.input, height: "100px", resize: "vertical" }}
          />

          <button type="submit" style={styles.button}>
            Book Lesson
          </button>
        </form>

        {message && <p style={styles.message}>{message}</p>}
      </div>
    </TutorLayout>
  );
}

const styles = {
  container: {
    maxWidth: "500px",
    margin: "2rem auto",
    padding: "2rem",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    fontFamily: "'Poppins', sans-serif",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  input: {
    padding: "0.8rem",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "1rem",
  },
  button: {
    padding: "0.9rem",
    backgroundColor: "#4CAF50",
    color: "#fff",
    fontWeight: "bold",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  message: {
    marginTop: "1rem",
    fontWeight: "bold",
    color: "#2c3e50",
  },
};

export default BookLesson;
